import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

// --- Styles for Condensed PDF ---
const styles = StyleSheet.create({
  page: {
    paddingTop: 35,
    paddingBottom: 50, // More bottom padding for potential page numbers later
    paddingHorizontal: 40,
    fontFamily: 'Helvetica', // Use a standard built-in font
    fontSize: 9, // Smaller base font size
    lineHeight: 1.3,
  },
  title: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 15,
    fontFamily: 'Helvetica-Bold',
  },
  cardBlock: {
    marginBottom: 10,
    paddingBottom: 5,
    borderBottomWidth: 0.5,
    borderBottomColor: '#cccccc',
  },
  cardName: {
    fontSize: 11,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 3,
  },
  text: {
    fontSize: 9,
    marginBottom: 1,
    // Allow text to wrap naturally
  },
  label: {
    fontFamily: 'Helvetica-Bold',
  },
  equipmentList: {
    // Can potentially style this differently if needed
  }
});
// --- End Styles ---

// --- Helper Function (copied for self-containment or import from utils) ---
const formatStat = (value) => (value != null && value > 0 ? `+${value}` : value ?? 'N/A');

// --- The Condensed PDF Document Component ---
const ForbiddenPsalmRosterPDF = ({ warband, warbandName }) => (
  <Document>
    {/* Use Portrait Orientation */}
    <Page size="LETTER" orientation="portrait" style={styles.page}>
      <Text style={styles.title}>{warbandName || 'Warband Roster'}</Text>

      {warband && warband.map((card, index) => (
        // Use wrap={false} to try and keep each member block together
        <View key={index} style={styles.cardBlock} wrap={false}>
          {card.stats ? (
            // --- Character Layout ---
            <>
              <Text style={styles.cardName}>{card.name} {card.title}</Text>
              {/* Combine stats into a denser line */}
              <Text style={styles.text}>
                <Text style={styles.label}>Stats:</Text> Ag: {formatStat(card.stats.Agility)} | Pr: {formatStat(card.stats.Presence)} | St: {formatStat(card.stats.Strength)} | To: {formatStat(card.stats.Toughness)} | HP: {card.stats.HP ?? 'N/A'} | Mv: {card.stats.Movement ?? 'N/A'}
              </Text>
              <Text style={styles.text}><Text style={styles.label}>Weapon:</Text> {card.weapon || 'None'}</Text>
              <Text style={styles.text}><Text style={styles.label}>Armor:</Text> {card.armor || 'None'}</Text>
              <Text style={styles.text}><Text style={styles.label}>Feats:</Text> {card.feats || 'None'}</Text>
              <Text style={styles.text}><Text style={styles.label}>Flaws:</Text> {card.flaws || 'None'}</Text>
              <Text style={styles.text}><Text style={styles.label}>Equipment:</Text> {Array.isArray(card.equipment) ? (card.equipment.length > 0 ? card.equipment.join(', ') : 'None') : 'None'}</Text>
              {/* Only show notes if they exist */}
              {card.Notes && <Text style={styles.text}><Text style={styles.label}>Notes:</Text> {card.Notes}</Text>}
            </>
          ) : (
            // --- Scroll Layout ---
            <>
              {/* Use title or default if missing */}
              <Text style={styles.cardName}>{card.title || 'Scrolls'}</Text>
              <Text style={styles.text}><Text style={styles.label}>Clean:</Text> {card.cleanScroll || 'N/A'}</Text>
              <Text style={styles.text}><Text style={styles.label}>Unclean:</Text> {card.uncleanScroll || 'N/A'}</Text>
              {/* Only show notes if they exist */}
              {card.Notes && <Text style={styles.text}><Text style={styles.label}>Notes:</Text> {card.Notes}</Text>}
            </>
          )}
        </View>
      ))}

      {/* Optional: Add Page Numbers */}
      <Text style={{ position: 'absolute', fontSize: 8, bottom: 30, left: 0, right: 40, textAlign: 'right' }} render={({ pageNumber, totalPages }) => (
        `${pageNumber} / ${totalPages}`
      )} fixed />
    </Page>
  </Document>
);

export default ForbiddenPsalmRosterPDF;
